import { useTheme, useMediaQuery, Grid, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { useFormContext } from '../Context/Context';
import { useLocation } from 'react-router-dom';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';
import { addColumn, fillInputValue, handleAddRow, handleClickOutside, handleColumnDelete, handleColumnTitleChange, handleCondition, handleHeadingFocus, handleRadioChange, handleRowDelete, handleRowTitleChange } from '../helpers/tableHelpers';

const Table = ({ id }) => {


    const { drawerData } = useFormContext();
    const location = useLocation();
    const currentPage = location.pathname;
  
    const existingComponentIndex = drawerData.findIndex(
      (component) => component.id === id
    );
    const { readOnly } = useReadOnly();
    const { finalSelectValues } = useContext(FinalValuesContext);
  
    const switchRow =
      drawerData[existingComponentIndex]?.state.rowTitles.length > 0
        ? drawerData[existingComponentIndex].state.rowTitles
        : ['کیفیت خدمات', 'پاکیزگی', 'پاسخگویی', 'دوستی'];
  
    const switchColumn =
      drawerData[existingComponentIndex]?.state.columnTitles.length > 0
        ? drawerData[existingComponentIndex].state.columnTitles
        : ['عدم رضایت', 'رضایت نسبی', 'رضایت', 'رضایت کامل'];
  
    const switchHeader =
      drawerData[existingComponentIndex]?.state.tableValue ||
      'جدول ورودی';
  
    const isReadOnly =
      currentPage.startsWith('/publish') ||
      currentPage.startsWith('/card-form/publish') ||
      currentPage.startsWith('/user/fill-form/');
  
    const [tableValue, setTableValue] = useState(switchHeader);
    const [rowTitles, setRowTitles] = useState(switchRow);
    const [columnTitles, setColumnTitles] = useState(switchColumn);
    const [selected, setSelected] = useState(Array(columnTitles.length).fill(null));
    const [show, setShow] = useState(false);
    const [isSubHeaderVisible, setSubHeaderVisible] = useState(false);
    const [isHeadingFocused, setHeadingFocused] = useState(false);
    const [condition, setCondition] = useState(false);
  
    const initialSelectedColumnState =
      drawerData[existingComponentIndex]?.state.mainSelectedColumnIndex ||
      Array(rowTitles.length).fill({ row: null, column: null });
    const [selectedColumnIndex, setSelectedColumnIndex] = useState(
      initialSelectedColumnState
    );
  
    const containerRef = useRef(null);
  
    let titleIndex = finalSelectValues.findIndex(
      (item) => item.name === 'FieldCondition'
    );
    let title = ConvertTitle({
      title: finalSelectValues[titleIndex]?.value,
    });
    let dataIndex = drawerData.findIndex((item) => item.title === title);
    let dataCondition = drawerData[dataIndex]?.state.readOnly;
  
    const clickOutsideHandler = handleClickOutside(
      containerRef,
      setSubHeaderVisible,
      setHeadingFocused,
      setShow
    );
  
    useEffect(() => {
      const fetchData = async () => {
        await fillInputValue(
          drawerData,
          existingComponentIndex,
          tableValue,
          rowTitles,
          columnTitles,
          selectedColumnIndex,
          show,
          readOnly
        );
      };
      fetchData();
    }, [id, tableValue, rowTitles, columnTitles, selectedColumnIndex, show]);
  
    useEffect(() => {
      document.addEventListener('click', clickOutsideHandler);
      return () => {
        document.removeEventListener('click', clickOutsideHandler);
      };
    }, []);
  
    useEffect(() => {
      handleCondition(currentPage, readOnly, dataCondition, title, setCondition);
    }, [finalSelectValues, readOnly]);
  
    const theme = useTheme();
    const HeadingColor = theme.palette.blue[700];


    return (
        <Grid>
            <Grid
                mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
                p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
                mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
                borderRadius={'3px'}
                width={'100%'}
                bgcolor={'white'} ref={containerRef}
                border={`2px solid ${isHeadingFocused && drawerData.length > 0 && drawerData[existingComponentIndex] && !isReadOnly ? '#0293e2' : 'transparent'}`}
                onClick={handleClickOutside}>
                <Grid className={'HeadingInput'} pb={'14px'}>
                    <input
                        readOnly={isReadOnly || condition}
                        className="customHead-input" placeholder={'یک عنوان وارد کنید'} style={{
                            border: 'none',
                            outline: 'none',
                            userSelect: 'text',
                            wordWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            width: '100%',
                            fontSize: '16px',
                            fontWeight: 700,
                            lineHeight: 1.45,
                            color: HeadingColor,
                            '::placeholder': {
                                color: '#b8bdc9', // Placeholder text color
                            },
                        }}
                        value={tableValue}
                        onChange={(e) => setTableValue(e.target.value)}
                        onClick={handleClickOutside}
                        onFocus={isReadOnly ? null : (e) => handleHeadingFocus(setHeadingFocused, e)}
                    />
                </Grid>
                <Grid className="table-container" display={'flex'} alignItems={'center'} position={'relative'}>
                    <Grid width={'fit-content'} onClick={isReadOnly || condition ? null : () => addColumn(columnTitles, setColumnTitles)} display={show && !isReadOnly ? 'flex' : "none"} alignItems={'center'} gap={'4px'}
                        style={{ cursor: 'pointer' }} className='addColumn' position={'absolute'} right={'-30px'}
                        top={'50px'}>
                        <Typography variant={'subtitle1'} color={'darkgray'} style={{ whiteSpace: 'nowrap' }}
                            className='AddColumn'>افزودن ستون</Typography>
                        <AddIcon className='' />
                    </Grid>
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th style={{ width: '140px' }}></th>
                                {columnTitles.map((title, index) => (
                                    <th className="row-header" key={index} style={{ width: '140px' }}>
                                        <Grid className="input-container">
                                            <input
                                                readOnly={isReadOnly || condition}
                                                placeholder='عنوان' style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    outline: 'none',
                                                    backgroundColor: 'transparent'
                                                }} type="text" value={title}
                                                onChange={(e) =>
                                                    handleColumnTitleChange(
                                                      index,
                                                      e,
                                                      columnTitles,
                                                      setColumnTitles,
                                                      selectedColumnIndex,
                                                      setSelectedColumnIndex
                                                    )
                                                  } />
                                            <CloseIcon style={{
                                                color: show ? 'darkgray' : 'transparent',
                                                cursor: 'pointer',
                                                display: show && !isReadOnly ? 'block' : 'none'
                                            }}
                                                onClick={isReadOnly || condition ? null : () =>
                                                    handleColumnDelete(
                                                      index,
                                                      columnTitles,
                                                      setColumnTitles,
                                                      selectedColumnIndex,
                                                      setSelectedColumnIndex
                                                    )} className="delete-icons" />
                                        </Grid>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rowTitles.map((title, rowIndex) => (
                                <tr key={rowIndex}>
                                    <th className="row-header" style={{ width: '140px' }}>
                                        <Grid className="input-container">
                                            <input readOnly={isReadOnly || condition} placeholder='عنوان'
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    outline: 'none',
                                                    backgroundColor: 'transparent'
                                                }} type="text" value={title}
                                                onChange={(e) =>
                                                    handleRowTitleChange(
                                                      rowIndex,
                                                      e,
                                                      rowTitles,
                                                      setRowTitles,
                                                      selectedColumnIndex,
                                                      setSelectedColumnIndex
                                                    )
                                                  } />
                                            <CloseIcon style={{
                                                color: show ? 'darkgray' : 'transparent',
                                                cursor: 'pointer',
                                                display: show && !isReadOnly ? 'block' : 'none'
                                            }}
                                                onClick={isReadOnly || condition ? null : () =>
                                                    handleRowDelete(
                                                      rowIndex,
                                                      rowTitles,
                                                      setRowTitles,
                                                      selectedColumnIndex,
                                                      setSelectedColumnIndex,
                                                      selected,
                                                      setSelected
                                                    )} className="delete-icons" />
                                        </Grid>
                                    </th>
                                    {columnTitles.map((_, colIndex) => (
                                        <td key={colIndex} style={{ marginRight: "50%" }}>
                                            <Grid className="input-container">
                                                <input
                                                    disabled={condition}
                                                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                                    type="radio"
                                                    checked={selected[rowIndex] === colIndex}
                                                    onChange={() =>
                                                        handleRadioChange(
                                                          rowIndex,
                                                          colIndex,
                                                          selected,
                                                          setSelected,
                                                          rowTitles,
                                                          columnTitles,
                                                          selectedColumnIndex,
                                                          setSelectedColumnIndex
                                                        )}
                                                />
                                            </Grid>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Grid>
                <Grid width={'fit-content'} display={show && !isReadOnly ? 'flex' : "none"} alignItems={'center'} gap={'4px'} mr={'20px'}
                    style={{ cursor: 'pointer' }} className='AddColumn' onClick={isReadOnly || condition ? null : () =>
                        handleAddRow(
                          rowTitles,
                          setRowTitles,
                          selectedColumnIndex,
                          setSelectedColumnIndex,
                          selected,
                          setSelected
                        )}>
                    <Typography variant={'subtitle1'} className='AddColumn'>افزودن سطر</Typography>
                    <AddIcon />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Table
